const ADMIN2_BASE_URL = process.env.VUE_APP_ADMIN2_URL || 'https://admin2.manet-marketing.de'

export const buildAdmin2ObjectLocalizationEditUrl = (objectId, lang = 'de') => {
  if (!objectId) {
    return null
  }

  const localizationLang = lang || 'de'
  return `${ADMIN2_BASE_URL}/platform/objects/${objectId}/localizations/${localizationLang}/edit`
}
